import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap:28px;
  width: 100%;

`;

export const DataAccesBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 1375px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const DataAccesBarLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  @media (max-width: 1375px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
    
   & > div > div:first-child{
       width: auto;
       min-width: auto;
       max-height: 40px;
   } 
`;

export const SearchContainer = styled.div`
  min-width: 200px;
  max-width: 257px;
  
  @media (max-width: 1375px) {
    width: 100%;
  }
`;

export const DesktopButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  @media (max-width: 1375px) {
    display: none;
  }
`;

export const DataAccesBarRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 1375px) {
    display: none;
  }
`;

export const BottomRow = styled.div`
  display: none;

  @media (max-width: 1375px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;

export const TabletSwitchMode = styled.div`
  display: none;

  @media (max-width: 1375px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
`;




